module.exports = __webpack_public_path__ + "img/ceramic-meh.59652798.jpg";